// Internal utilities
import { makeDownstreamApiCall, HTTP_METHODS } from "@swiggy-private/checkout-core";

// Types and interfaces
import { ApiResponse } from "@payment-client/interfaces/Api";
import { Headers } from "@payment-client/interfaces/Http";
import { CBCCPaymentOnboardingRequest, CBCCPaymentOnboardingResponse } from "@payment-client/interfaces/CBCC";

// constants
import { CBCC_FD_PLACE_ORDER_ENDPOINT } from "@payment-client/constants/Order";
import { DOWNSTREAM_HOSTS } from "@payment-client/constants/Hosts";

export async function placeCBCCPaymentOnboarding(
    params: CBCCPaymentOnboardingRequest,
    headers: Headers,
): Promise<ApiResponse<CBCCPaymentOnboardingResponse>> {
    return (await makeDownstreamApiCall<CBCCPaymentOnboardingResponse>(
        {
            apiHost: DOWNSTREAM_HOSTS.CBCC_API_HOST,
            endpoint: CBCC_FD_PLACE_ORDER_ENDPOINT,
            bodyParams: params,
            options: {
                method: HTTP_METHODS.POST,
                headers: {
                    ...headers,
                    "Content-Type": "application/json",
                },
            },
        },
        true,
    )) as ApiResponse<CBCCPaymentOnboardingResponse>;
}
